module.exports = __webpack_public_path__ + "static/RenAM-500E-d4a0f6c53be893f1d473179feb5dafc5.jpg";